module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"rack":"Rack","pdu":"PDU"},"de":{"rack":"Rack","pdu":"PDU"}}')
  delete Component.options._Ctor
}
